import Version from '../Config/Version'
import Envi from '../Config/Environment'

import cookie from 'js-cookie'

if (Envi.appStatus === 'PROD') {
    var hostVar = 'https://via06.generali.co.id'
    var routeHelper = 'youHelper'
    var routeEapp = 'youEapp'
    var routeOcr = 'omniOcr'
    var routeVidConvert = 'vidconvert'
    var routeVaBca='/cms-omni-ui/uploads/detail-va-offline/va_offline_bca/index.html?x='
    var routeHelper2 = 'omnihelper'

}
else {
    //for UAT
    var hostVar = 'https://uat-via06.generali.co.id'
    var routeHelper = 'uat-youhelper'
    var routeEapp = 'uat-youeapp'
    var routeOcr = 'uat-omniocr'
    var routeVidConvert = 'uat-vidconvert'
    var routeVaBca='/uat-cms-omni-ui/uploads/detail-va-offline/va_offline_bca/index.html?x='
    var routeHelper2 = 'uat-omnihelper'


}


class Api {
    static host = hostVar
    static routeHelper = routeHelper
    static routeEapp = routeEapp
    static routeOcr = routeOcr
    static routeVidConvert = routeVidConvert
    static routeVaBca = routeVaBca

    static headers() {
        return {
            'Content-Type': 'application/json',
            // 'traceparent' : this.generateTranceparent()
        }
    }

    static headersJWT() {
        let token = JSON.parse(localStorage.getItem("TOKEN")).token;
        return {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
            // 'traceparent' : this.generateTranceparent()
        }
    }

    static headersFormDataJWT() {
        let token = JSON.parse(localStorage.getItem("TOKEN")).token;
        return {
            'Authorization': `Bearer ${token}`,
            // 'traceparent' : this.generateTranceparent()
        }
    }

    static get(route) {
        return this.xhr(route, null, 'GET')
    }

    static put(route, params) {
        return this.xhr(route, params, 'PUT')
    }

    static post(route, params) {
        return this.xhr(route, params, 'POST')
    }

    static delete(route, params) {
        return this.xhr(route, params, 'DELETE')
    }


    
      

    static async xhr(route, params, verb) {
        const url = `${this.host}/${route}`
        let options = Object.assign({ method: verb }, verb != 'GET' && params ? { body: JSON.stringify(params) } : null);
        options.headers = url.includes(this.routeEapp) ? Api.headersJWT() : url.includes("/customer/logout") ? Api.headersJWT() : Api.headers();
        
        var timeOut = new Promise(function (resolve, reject) {
            setTimeout(() => reject({ "status": false, status_message: 'Connection Timeout, Harap Coba Lagi!', url: url, httpStatus: 500 }), 60000);
        });
        
        let epochStart = Date.now();

        var fetcher = new Promise(function (resolve, reject) {
            fetch(url, options)
                .then((response) =>
                    response.json().then(data => ({
                        url,
                        params,
                        data,
                        status: true,
                        httpStatus: response.status
                    }))
                )
                .then((res) => {

                    if (res.httpStatus == 401 && (res.data.hasOwnProperty("exp") && res.data['exp'] == "token expired")) {
                        Api.xhrRefreshToken()
                            .then(async (resp) => {
                                resolve(await Api.xhr(route, params, verb));
                            }).catch((err) => {
                                reject(err);
                            })

                    } else {
                        resolve(res.data);
                    }
                })
                .catch(function (error) {

                    if (error == 'TypeError: Network request failed') {
                        reject({ status: false, status_message: 'Connection Timeout, Harap Coba Lagi!', url: url, httpStatus: 500 });
                    } else {
                        reject({ status: false, status_message: 'Error Response', url: url, httpStatus: 500 });
                    }
                })
        });

        return Promise.race([fetcher, timeOut])
            .then(function (res) {
                return res
            })
            .catch(function (error) {
                return { status: false, status_message: error.status_message, url: url, httpStatus: 500 };
            });
    }

    static FormData(route, data) {
        let headers = Api.headersFormDataJWT()
        const url = `${this.host}/${route}`
        var fetcher = new Promise((resolve, reject) => {
            fetch(url, {
                headers: headers,
                method: 'POST',
                body: data,
            })
                .then((response) =>
                    response.json().then(data => ({
                        data: data,
                        status: true,
                        httpStatus: response.status
                    }))
                )
                .then((res) => {
                    if (res.httpStatus == 401 && (res.data.hasOwnProperty("exp") && res.data['exp'] == "token expired")) {
                        Api.xhrRefreshToken()
                            .then(async (resp) => {
                                resolve(await Api.xhr(route, params, verb));
                            }).catch((err) => {
                                reject(err);
                            })

                    } else {
                        resolve(res);
                    }
                })
                .catch(function (error) {
                    reject({ status: false, message: error, url: url, httpStatus: 500 });
                })
        });

        return fetcher
            .then(function (res) {
                return res;
            })
            .catch(function (error) {
                return { status: false, message: error, url: url, httpStatus: 500 };
                throw error;
            });
    }

    static xhrRefreshToken() {
        const userAgent = navigator.userAgent.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || []
        const SPAJs = JSON.parse(localStorage.getItem("SPAJ_HEADER"));
        // let refreshToken = cookie.get("refreshToken")

        let refreshToken = JSON.parse(localStorage.getItem("TOKEN")).refreshToken;
        const url_refresh = `${this.host}/${this.routeHelper}/helper/v2/customer/refresh-token`;
        return new Promise((resolve, reject) => {
            fetch(url_refresh, {
                method: 'POST',
                body: JSON.stringify({
                    deviceId: `${userAgent[1]}`,
                    userName: `${SPAJs.userName}`,
                    spajNumber: `${SPAJs.spajNumber}`
                }),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${refreshToken}`,
                    // 'traceparent' : Api.generateTranceparent()
                }
            }).then((rest) =>
                rest.json().then(d => ({
                    url_refresh,
                    data: d,
                    status: true,
                    httpStatus: rest.status
                }))
            ).then(async (resp) => {
                // cookie.set("accessToken", await resp.data.token, { expires: 1 });
                let newToken = JSON.parse(localStorage.getItem("TOKEN"))
                newToken.token = await resp.data.data.token;
                localStorage.setItem("TOKEN", JSON.stringify(newToken));
                sessionStorage.setItem("TOKEN_SESSION", JSON.stringify(newToken));
                resolve(resp);
            }).catch((err) => {
                reject({ status: false, status_message: "Unauthorized", url: url, httpStatus: 401 });
            })
        })
    }

    static generateTranceparent(){
        const traceId = this.generateRandomHex(32);
        const spanId = this.generateRandomHex(16);
        // console.log("Generated traceparent: ", `00-${traceId}-${spanId}-01`);
        return `00-${traceId}-${spanId}-01`;
    }

    static generateRandomHex(length) {
        const hexChars = '0123456789abcdef';
        let result = '';
        for (let i = 0; i < length; i++) {
        result += hexChars[Math.floor(Math.random() * 16)];
        }
        return result;
    }

}

export default Api